export default __webpack_public_path__ + "static/media/pix-icon.a61bf77e.svg";